export default __webpack_public_path__ + "static/media/closeUptwo.bad2a596.png";